import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e788e67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-no-wrap justify-between w-full" }
const _hoisted_2 = { class: "w-1/4 h-full first-level-max-height o-scrollbar overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { role: "menu" }
const _hoisted_4 = { role: "none" }
const _hoisted_5 = { role: "none" }
const _hoisted_6 = ["href", "title", "target", "aria-haspopup", "aria-owns", "aria-expanded", "aria-current", "onKeydown", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "mt-50",
  role: "none"
}
const _hoisted_8 = ["href", "title", "target", "aria-current", "onKeydown", "onClick"]
const _hoisted_9 = { class: "c-magic-line inline mr-13" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "w-full h-full flex flex-no-wrap justify-end" }
const _hoisted_12 = { class: "flex-1 relative" }
const _hoisted_13 = { class: "h-full absolute inset-0" }
const _hoisted_14 = ["id"]
const _hoisted_15 = {
  class: "min-h-0 flex w-full",
  role: "none"
}
const _hoisted_16 = {
  class: "w-full",
  role: "none"
}
const _hoisted_17 = {
  class: "columns-2 column-gap-20 columns-fill-auto h-full",
  role: "none"
}
const _hoisted_18 = ["href", "title", "target", "aria-owns", "aria-haspopup", "aria-expanded", "aria-current", "onKeydown", "onClick"]
const _hoisted_19 = { class: "c-magic-line inline mr-13" }
const _hoisted_20 = { class: "c-magic-line inline mr-13" }
const _hoisted_21 = {
  key: 0,
  class: "mt-20 px-20",
  role: "none"
}
const _hoisted_22 = {
  key: 0,
  role: "none",
  class: "pt-60 flex flex-col"
}
const _hoisted_23 = ["href", "title", "target", "aria-current", "onKeydown", "onClick"]
const _hoisted_24 = { class: "c-magic-line inline mr-13" }
const _hoisted_25 = { class: "c-magic-line c-magic-line--parent-hover inline-block mt-15 text-20 font-cormorant" }
const _hoisted_26 = {
  key: 1,
  class: "w-3/8",
  style: {"aspect-ratio":"100 / 67"}
}

import { computed, defineAsyncComponent, watch } from 'vue';
import navigationStore from '@/shared/navigation/navigation.store';
import { NavigationItemContentModel, NavigationItemModel } from '@/types/B2CcontentServerContract';
import LogoutLink from '@/shared/navigation/LogoutLink.vue';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import authStore from '@/shared/auth/auth.store';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';
import AnimatedDivider from '@/shared/navigation/site-navigation/AnimatedDivider.vue';
import useDivider from '@/shared/navigation/site-navigation/useDivider';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavigation',
  setup(__props) {

const MainNavigationItemLabel = defineAsyncComponent(() => import('@/shared/navigation/site-navigation/MainNavigationItemLabel.vue'));

const {
    setDividerHeight,
} = useDivider();

const {
    profileLinks,
    accountName,
    shouldShowLogout,
} = useProfile();

const contentItems = computed<NavigationItemContentModel[]>(() => {
    let items = navigationStore?.activeMainNavigationItem?.content ?? [] as NavigationItemContentModel[];
    let maxLength = 2;
    if (navigationStore.activeSubNavigationItem) {
        items = navigationStore.activeSubNavigationItem?.content ?? [] as NavigationItemContentModel[];
        maxLength = 1;
    }
    const length = Math.min(items.length, maxLength);
    return items.slice(0, length).reverse();
});

const getIsSelectedSubNavigationItem = (item: NavigationItemModel) => {
    return subNavigation.value && subNavigation.value === item;
};

const getShouldShowAccountName = (item: NavigationItemModel) => {
    return authStore.isSignedIn && navigationStore.getIsMyBoliaItem(item);
};

const shouldShowMyBoliaLinks = computed<boolean>(() => {
    if (!navigationStore.activeSubNavigationItem) {
        return false;
    }
    return navigationStore.getIsMyBoliaItem(navigationStore.activeSubNavigationItem);
});

const items = computed(() => {
    const activeItems = navigationStore.activeMainNavigationItems;
    return activeItems;
});

const specialLinks = computed(() => {
    const links = navigationStore.activeMainNavigationItem?.specialLinks ?? [];
    return links;
});

const subNavigation = computed(() => {
    return navigationStore.activeSubNavigationItem;
});

const onSubNavigationClick = (item) => {
    navigationStore.handleSubNavigationClick(item);
    navigationTrackingService.menuItem(item);
};

const getAriaControlsId = (item: NavigationItemModel) => {
    return item.items ? item.id : null;
};

const getAriaExpandedState = (item: NavigationItemModel) => {
    return item.items ? getIsSelectedSubNavigationItem(item) : null;
};

const getAriaCurrentState = (item: NavigationItemModel) => {
    const currentValue = window.location.pathname === item.url ? 'page' : false;
    return item.url && !item.items ? currentValue : null;
};

const getAriaHasPopup = (item: NavigationItemModel) => {
    return item.items ? 'menu' : null;
};

watch(items, (items) => {
    const myBoliaItem = items.find(item => navigationStore.getIsMyBoliaItem(item));
    if (myBoliaItem) {
        navigationStore.setActiveSubNavigationItem(myBoliaItem);
    }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name+idx,
                class: "mt-20 first:mt-0",
                role: "none"
              }, [
                _createElementVNode("a", {
                  href: item?.url,
                  title: item.name,
                  target: item.target,
                  class: "c-menu-item",
                  tabindex: "0",
                  role: "menuitem",
                  "aria-haspopup": getAriaHasPopup(item),
                  "aria-owns": getAriaControlsId(item),
                  "aria-expanded": getAriaExpandedState(item),
                  "aria-current": getAriaCurrentState(item),
                  onKeydown: _withKeys(_withModifiers(($event: any) => (onSubNavigationClick(item)), ["prevent"]), ["enter"]),
                  onClick: _withModifiers(($event: any) => (onSubNavigationClick(item)), ["prevent"])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["c-magic-line inline mr-13 relative z-1", { 'font-bold c-magic-line--underline': getIsSelectedSubNavigationItem(item) }])
                  }, _toDisplayString(item.name), 3),
                  (getShouldShowAccountName(item))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(_unref(accountName)) + ") ", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.label)
                    ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                        key: 1,
                        label: item.label
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_6)
              ]))
            }), 128))
          ]),
          (_unref(specialLinks).length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specialLinks), (link, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: link.name+idx,
                    class: "mt-20 first:mt-0",
                    role: "none"
                  }, [
                    _createElementVNode("a", {
                      href: link?.url,
                      title: link.name,
                      target: link.target,
                      role: "menuitem",
                      class: "c-menu-item",
                      "aria-current": getAriaCurrentState(link),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (onSubNavigationClick(link)), ["prevent"]), ["enter"]),
                      onClick: _withModifiers(($event: any) => (onSubNavigationClick(link)), ["prevent"])
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(link.name), 1),
                      (link.label)
                        ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                            key: 0,
                            label: link.label
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_8)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(subNavigation))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _unref(subNavigation).id,
          class: "pl-20 w-3/8"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_unref(subNavigation))
                  ? (_openBlock(), _createBlock(AnimatedDivider, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, {
                  name: "o-anim-fade-200",
                  mode: "out-in",
                  appear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("nav", {
                      key: _unref(subNavigation)?.id ?? 0,
                      class: "h-full pl-60"
                    }, [
                      _createElementVNode("div", {
                        id: _unref(subNavigation).id,
                        ref: _unref(setDividerHeight),
                        class: "o-scrollbar-x inline-flex flex-col w-full",
                        role: "menu",
                        style: {"max-height":"100%"}
                      }, [
                        _createElementVNode("ul", _hoisted_15, [
                          _createElementVNode("li", _hoisted_16, [
                            _createElementVNode("ul", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subNavigation).items, (item, idx) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: item.name+idx,
                                  role: "none",
                                  class: _normalizeClass(["px-20", {'mt-20': idx !== 0}])
                                }, [
                                  _createElementVNode("a", {
                                    href: item?.url,
                                    title: item.name,
                                    target: item.target,
                                    class: "c-menu-item",
                                    "aria-owns": getAriaControlsId(item),
                                    "aria-haspopup": getAriaHasPopup(item),
                                    "aria-expanded": getAriaExpandedState(item),
                                    "aria-current": getAriaCurrentState(item),
                                    role: "menuitem",
                                    onKeydown: _withKeys(_withModifiers(($event: any) => (onSubNavigationClick(item)), ["prevent"]), ["enter"]),
                                    onClick: _withModifiers(($event: any) => (onSubNavigationClick(item)), ["prevent"])
                                  }, [
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.name), 1),
                                    (item.label)
                                      ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                                          key: 0,
                                          label: item.label
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ], 40, _hoisted_18)
                                ], 2))
                              }), 128)),
                              (_unref(shouldShowMyBoliaLinks))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profileLinks), (item, idx) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: item.name+idx,
                                        role: "none",
                                        class: "mt-20 px-20"
                                      }, [
                                        _createVNode(RouterLinkConditional, {
                                          to: item.url,
                                          "spa-enabled": item.spaLink,
                                          title: item.name,
                                          role: "menuitem",
                                          class: "c-menu-item",
                                          onClick: ($event: any) => (_unref(navigationTrackingService).myBoliaProfileLinks(item))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(item.name), 1),
                                            (item.label)
                                              ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                                                  key: 0,
                                                  label: item.label
                                                }, null, 8, ["label"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "spa-enabled", "title", "onClick"])
                                      ]))
                                    }), 128)),
                                    (_unref(shouldShowLogout))
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                          _createVNode(LogoutLink, {
                                            class: "text-roman c-magic-line inline hover:text-roman",
                                            role: 'menuitem',
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navigationTrackingService).logoutLink()))
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        (_unref(subNavigation).specialLinks?.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subNavigation).specialLinks, (link, idx) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: link.name+idx,
                                  role: "none",
                                  class: "mt-20 px-20 first:mt-0"
                                }, [
                                  _createElementVNode("a", {
                                    href: link?.url,
                                    title: link.name,
                                    target: link.target,
                                    role: "menuitem",
                                    class: "c-menu-item",
                                    "aria-current": getAriaCurrentState(link),
                                    onKeydown: _withKeys(_withModifiers(($event: any) => (onSubNavigationClick(link)), ["prevent"]), ["enter"]),
                                    onClick: _withModifiers(($event: any) => (onSubNavigationClick(link)), ["prevent"])
                                  }, [
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(link.name), 1),
                                    (link.label)
                                      ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                                          key: 0,
                                          label: link.label
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ], 40, _hoisted_23)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_14)
                    ]))
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 8, _hoisted_10))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentItems), (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name + idx,
        class: "pl-20 w-3/8",
        style: {"aspect-ratio":"100 / 66"}
      }, [
        _createVNode(RouterLinkConditional, {
          to: item.url,
          "spa-enabled": item.isSpaLink,
          title: item.name,
          class: "block text-center",
          onClick: ($event: any) => (_unref(navigationTrackingService).menuItem(item))
        }, {
          default: _withCtx(() => [
            _createVNode(MediaHandler, {
              "media-block": item.media,
              "media-aspect-ratio": 5/3,
              "image-alt-text-override": item.name,
              "image-width-on-screen": 33
            }, null, 8, ["media-block", "image-alt-text-override"]),
            _createElementVNode("span", _hoisted_25, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to", "spa-enabled", "title", "onClick"])
      ]))
    }), 128)),
    (!_unref(contentItems)[0])
      ? (_openBlock(), _createElementBlock("div", _hoisted_26))
      : _createCommentVNode("", true)
  ]))
}
}

})